import { MessageCircle } from 'lucide-react';

export default function WhatsAppFloat() {
  return (
    <a
      href="https://api.whatsapp.com/send/?phone=5562994767293&text&type=phone_number&app_absent=0"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Contato via WhatsApp"
      className="whatsapp-float fixed bottom-24 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all flex items-center justify-center"
    >
      <MessageCircle size={28} fill="white" strokeWidth={0} />
    </a>
  );
}
